
import { Vue, Component } from 'vue-property-decorator';
import { component as Viewer } from 'v-viewer';
import lazyInject from '@/di';
import SupplyService from '@/services/supply.service';

@Component({
  components: {
    Viewer,
  },
})
export default class InvoiceDetailModal extends Vue {
  visible = false;

  loading = false;

  // 列表行数据，详情未返回时用于兜底展示
  record: any = {};

  // 发票详情
  detail: any = {};

  // 当前 TAB：0 高德——大有、1 大有——经销商、2 供应商——高德
  tabKey = '0';

  images: any[] = [];

  statusMap: any = {
    0: '未开票',
    1: '开票中',
    2: '已开票',
  };

  @lazyInject(SupplyService)
  supplyService!: SupplyService;

  get isDistributor() {
    return this.tabKey === '1';
  }

  // 详情优先，缺失字段回落列表行数据
  get info(): any {
    return { ...this.record, ...this.detail };
  }

  get amountExcludingTax() {
    return Number(this.info.amount_excluding_tax) || 0;
  }

  // 税额：接口有值直接取，否则按不含税金额 13% 计算（四舍五入保留两位）
  get taxAmount() {
    const tax = this.info.tax_amount;
    if (tax !== undefined && tax !== null && tax !== '' && !Number.isNaN(Number(tax))) {
      return Number(tax).toFixed(2);
    }
    return (Math.round(this.amountExcludingTax * 0.13 * 100) / 100).toFixed(2);
  }

  // 价税合计：接口有值直接取，否则 = 不含税金额 + 税额
  get totalWithTax() {
    const total = this.info.plat_amount;
    if (total !== undefined && total !== null && total !== '' && !Number.isNaN(Number(total))) {
      return Number(total).toFixed(2);
    }
    const tax = Number(this.taxAmount) || 0;
    return (Math.round((this.amountExcludingTax + tax) * 100) / 100).toFixed(2);
  }

  get statusText() {
    return this.statusMap[this.info.status] || this.info.status || '';
  }

  async open(record: any, tabKey?: string | number) {
    this.record = record || {};
    this.tabKey = tabKey === undefined ? '0' : `${tabKey}`;
    this.detail = {};
    this.images = [];
    this.visible = true;
    await this.getDetail();
  }

  async getDetail() {
    this.loading = true;
    // 大有——经销商走经销发票详情；其余按 category（TAB 0 -> 1，TAB 2 -> 3）
    const res: any = this.isDistributor
      ? await this.supplyService.getDistributorInvoiceInfo({
        order_no: this.record.order_no,
      })
      : await this.supplyService.getInvoiceDetail({
        batch_no: this.record.batch_no,
        category: +this.tabKey + 1,
      });
    this.loading = false;
    if (!res) {
      return;
    }
    // 查看发票接口直接返回发票图片地址数组（如 ['https://xxx.png']，无票时为 ['']）
    if (Array.isArray(res)) {
      this.images = this.normalizeImages(res);
      return;
    }
    if (typeof res !== 'object') {
      return;
    }
    // 兼容包裹结构：{ detail: {...} } 或详情对象
    this.detail = res.detail || res;
    this.images = this.normalizeImages(this.pickImages(this.detail));
  }

  // 发票图片字段后端命名未统一，按常见字段依次取第一个有值的
  pickImages(data: any): any[] {
    const keys = ['invoice', 'invoices', 'invoice_images', 'license', 'images', 'resource'];
    const value = keys
      .map((key) => data[key])
      .find((item) => (Array.isArray(item) ? item.length > 0 : !!item));
    if (!value) {
      return [];
    }
    if (typeof value === 'string') {
      return value.split(',').filter((url: string) => url !== '');
    }
    return Array.isArray(value) ? value : [value];
  }

  // 统一为 v-viewer 需要的 { source, thumbnail, alt } 结构，过滤空串占位
  normalizeImages(list: any[]): any[] {
    if (!list || !list.length) {
      return [];
    }
    return list
      .map((item: any) => {
        if (typeof item === 'string') {
          return item ? { source: item, thumbnail: item, alt: '' } : null;
        }
        if (item.source) {
          return item;
        }
        if (item.url) {
          return { source: item.url, thumbnail: item.url, alt: item.alt || '' };
        }
        return null;
      })
      .filter(Boolean);
  }

  onClose() {
    this.visible = false;
    this.record = {};
    this.detail = {};
    this.images = [];
  }
}
